export enum GregorioType {
  NOTE,
  GLYPH,
  ELEMENT,
  CLEF,
  END_OF_LINE,
  SPACE,
  BAR,
  CUSTOS,
  MANUAL_CUSTOS,
  SUPPRESS_CUSTOS,

  TEXVERB_GLYPH,
  TEXVERB_ELEMENT,

  ALT,
  NLBA,
  AUTOFUSE_START,
  AUTOFUSE_END,
}
